//Special type of dashboard to show all the shared reports
define('app/dashboard/panels/SegmentDashboardPanel',['require','./DashboardPanel','../DashboardEntitiesGridView','app/app','hbs!./SegmentDashboardPanel.hbs'],function(require) {

	'use strict';
	var DashboardPanel = require('./DashboardPanel'),
		DashboardEntitiesGridView = require('../DashboardEntitiesGridView'),
		App = require('app/app');

	return DashboardPanel.extend({
		template: require('hbs!./SegmentDashboardPanel.hbs'),

		onRender: function() {
			this.reportsToRefreshOnFilterChange = [];

			App.segments.fetch();

			this.generatePanel();
		},

		generatePanel: function() {
			var self = this;

			//add views
			self.addViews();

			// always preselect the reports tab
			var savedTab = '#dashboard-tab-reports';
			this.selectTab(savedTab);

			// allow widgets to be rearranged within their container.
			self.enableDragAndDrop();

			// disable the add report/widget panel if needed
			self.toggleDashboardControls();

			// Set event listeners
			self.setEventListeners();
		},

		addViews: function() {
			var self = this;
			//this view does not know when each of the 'DashboardEntitiesGridView' will be empty
			//because they are designed to work independently, and the specific "empty" logics
			//should not be a concern for this view

			window.setTimeout(function(model, filter) {
				self.generateViews(model, filter);
			}, 200, this.model, this.gridFilterSegments);
		},

		generateViews: function(model, filter) {
			App.segments.fetch();
			this.grid = new DashboardEntitiesGridView({
				dashboard: this.model,
				items: App.segments,
				itemType: 'segment',
				filter: filter
			});
			this.$('#dashboard-tab-reports').find('.entities-grid-container').append(this.grid.render().el);
		},

		gridFilterSegments: function(entity, dashboardOwner) {
			if (App.user.isInternalUser()) {
				return (dashboardOwner === entity.get('owner'));
			} else {
				return entity.isOwner();
			}
		}
	});
});

